
export class MeetingType {
    title: string;
    description: string;
    location: string;
    agendaTemplate: Number;
    sectionHeader: SectionHeader[] = [];
    attendees: string[];
    agendaItems: WorkFlowDetails = new WorkFlowDetails();
    agenda: WorkFlowDetails = new WorkFlowDetails();
    meetingMinutes: WorkFlowDetails = new WorkFlowDetails();
    colorHexCode: string;
    meetingTypeId: Number = 0;
    neededResetAI?: Boolean;
    neededResetAgenda?: Boolean;
    neededResetMinutes?: Boolean;
}



export class SectionHeader {
    title: string;
    id: number;
    order: number;
    isEditable: Boolean = false;
    isDraggable: Boolean = true;

    constructor() {
        this.title = '';
        this.id = 0;
        this.order = 0;
        this.isEditable = false;
        this.isDraggable = false;

    }
}

export class AgendaTemplate {
    createdBy: number;
    createdDateTime: Date;
    id: number;
    title: string;
    updatedBy: number;
    updatedDateTime: Date;


}

export class AgendaAttendee {

    createdBy: number;
    createdDateTime: Date;
    id: number;
    name: string;
    status: string;
    title: string;
    updatedBy: number;
    updatedDateTime: Date;

}


export class MeetingTypeList {
    id: number;
    title: string;
    colorHexCode: string;
    selected: boolean;
    meetings: Array<MeetingList> = [];
    constructor() {
        this.id = 0;
        this.title = '';
        this.colorHexCode = '';
        this.selected = true;
        this.meetings = [];
       
    }
}



export class SettingMeetingTypeList {
    id: number;
    title: string;
    colorHexCode: string;
    selected: boolean;
    meetings: Array<MeetingList> = [];
    agendaItems: Array<AgendaItemList> = [];
    meetingAgendas: Array<Agenda> = [];
    constructor() {
        this.id = 0;
        this.title = '';
        this.colorHexCode = '';
        this.selected = true;
        this.meetings = [];
        this.agendaItems = [];
        this.meetingAgendas = [];
    }
}

export class MeetingList {
    id: number;
    recurringId: number;
    startDate: any;
    title: string;
    constructor() {
        this.id = 0;
        this.title = '';
        this.startDate = new Date();
        this.recurringId = 0;
    }
}
export class AgendaItemList {
    id: number;
    title: string;
    constructor() {
        this.id = 0;
        this.title = '';
    }
}
export class Agenda {
    id: number;
    title: string;
    constructor() {
        this.id = 0;
        this.title = '';
    }
}

export class WorkFlowDetails {
    type: Number;
    minApprovers: Number;
    maxApprovers: Number;
    approvers: Array<WorkFlowApprover>;
    isFormValid: Boolean;
    oldApprovers?: Array<WorkFlowApprover>;
    constructor() {
        this.type = 0;
        this.maxApprovers = 0;
        this.minApprovers = 0;
        this.approvers = [];
        this.isFormValid = true;
    }
}

export class WorkFlowApprover {
    approverId: string;
    sequence: number;
    status: string;
}

export class MeetingTypeAgendaTemplate {
    meetingTypeId: number;
    meetingTypeTitle: string;
}



